<script lang="jsx">
import { mapGetters, mapActions, mapMutations } from 'vuex'
import ClientForm from '../../components/ClientForm'
import ErrorBlock from '../../components/ErrorBlock'

const SpinnerView = () => (
  <div class="spinner-container">
    <div class="spinner" />
  </div>
)

const EditClient = ({ context, client, storeGroups, togglePaymentOrgForm }) => (
  <div class="card">
    <header>
      <h2>Edit {client.name}</h2>
    </header>
    <ClientForm
      context={context}
      storeGroups={storeGroups}
      client={client}
      buttonName="Update"
      togglePaymentOrgForm={togglePaymentOrgForm}
      action={() => context.updateClient()}
    />
  </div>
)

export default {
  computed: {
    ...mapGetters('clients', [
      'selectedClient',
      'userMailTemplates',
      'userActions',
      'clientLoading',
      'clientError',
      'saving',
      'updating',
      'clientSuccess',
      'saveSuccess',
      'updateSuccess',
      'paymentOrganizations',
      'showPaymentOrgForm',
      'get',
    ]),
    ...mapGetters('storeGroups', ['storeGroups']),
  },
  created() {
    this.initClient(this.$route.params.id)
  },
  methods: {
    ...mapMutations('clients', ['update', 'resetClient', 'addTier', 'removeTier']),
    ...mapActions('clients', ['initClient', 'updateClient', 'setUserMailTemplate', 'addNewPaymentOrganization']),
  },

  render() {
    return (
      <div class="page">
        {this.clientLoading && <SpinnerView />}
        {this.clientError && <ErrorBlock error={this.clientError} />}
        {this.clientSuccess && <EditClient context={this} client={this.selectedClient} storeGroups={this.storeGroups} />}
      </div>
    )
  },
}
</script>
